import { KeyboardCloseIcon } from './KeyboardCloseIcon';

/**
 * author: Google
 * id 8545C0A1-5625-422F-AF38-624FB54237D3
 * name keyboard-close
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/keyboard-close.svg
 * tags
 */
export const KeyboardHideIcon = KeyboardCloseIcon;
export default KeyboardHideIcon